<script>
    export let src = null;
    export let tenantKey = '';
    export let hasVideo;
    export let alt = '';
    export let fillContainer = false;
    export let animation = 'none';
    export let imgHeight;
</script>

<style>
    .image-container {
        position: relative;
        height: 100%;
        overflow: hidden;
        border-radius: .9rem;
    }
    .image {
        display: flex;
        justify-content: center;
        align-items: center;

        background: var(--no-media-color);
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='36' height='36' viewBox='0 0 24 24' fill='none' stroke='%23777777' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round' class='ai ai-Coffee'%3E%3Cpath d='M11 7c4.418 0 8 .895 8 2s-3.582 2-8 2-8-.895-8-2c0-.357.375-.693 1.033-.984'/%3E%3Cpath d='M3 9v9.343c0 1.061.44 2.08 1.409 2.513C5.624 21.399 7.711 22 11 22c3.29 0 5.377-.601 6.591-1.144.968-.433 1.409-1.452 1.409-2.513V9'/%3E%3Cpath d='M19 10v0a3 3 0 0 1 3 3v0a3 3 0 0 1-3 3v0'/%3E%3Cpath d='M7 3v4'/%3E%3Cpath d='M11 2v2'/%3E%3Cpath d='M15 4v3'/%3E%3C/svg%3E");
        background-size: 36px 36px;
        background-position: center center;
        background-repeat: no-repeat;

        width: 100%;
        height: 11.5rem;
        object-fit: cover;
        border-radius: .9rem;
    }

    .image--scale-animation {
        animation: scale-animation 5s infinite ease-in-out alternate;
    }

    @keyframes scale-animation {
        from { transform: scale(1); }
        to { transform: scale(1.2); }
    }

    .image--fill {
        width: 100%;
        height: 100%;
    }
    .video-icon {
        position: absolute;
        top: 0.5rem;
        right: 0.5rem;
        box-shadow: 0 0 16px 0 rgb(65 65 90 / 15%);
    }
    .adjustable-height {
        transition: height .5s ease;
    }
</style>

{#if (src)}

    <div class="image-container">

        <img class="image adjustable-height {animation === 'scale' ? 'image--scale-animation' : '' } {fillContainer ? 'image--fill' : ''}"
             style:height="{imgHeight}"
             src="https://patico-qr-test.s3.eu-west-3.amazonaws.com/{tenantKey}/_media_files/_196/{src}"
             loading="lazy"
             onerror="this.src='./images/fallback-image.svg'; this.style.backgroundImage = 'none'; this.style.objectFit = 'scale-down';"
             alt={alt}>

        {#if (hasVideo)}
            <img class="video-icon" src="./images/video.svg" loading="lazy" alt="{alt}">
        {/if}
    </div>

{:else }
    <div class="image adjustable-height {fillContainer ? 'image--fill' : ''}" style:height="{imgHeight}">
    </div>
{/if}
